import definitions from "../../definitions";
import BossBatwitch from "./BossBatwitch";
import BossBuffSow from "./BossBuffSow";
import BossCenticore from "./BossCenticore";
import BossChick from "./BossChick";
import BossCyclops from "./BossCyclops";
import BossFishMonster from "./BossFishMonster";
import BossGnomeBear from "./BossGnomeBear";
import BossQueenMoleworm from "./BossQueenMoleworm";
import BossSpider from "./BossSpider";
import BossStefan from "./BossStefan";
import BossSuzie from "./BossSuzie";

export default class BossFactory {
    /**
     * @param {string} id
     * @param {object} [properties={}]
     * @returns {Boss}
     */
    static create(id, properties = {}) {
        switch (id) {
            case definitions.BOSS_ID.BATWITCH: {
                return new BossBatwitch();
            }
            case definitions.BOSS_ID.BUFF_SOW: {
                return new BossBuffSow();
            }
            case definitions.BOSS_ID.CHICK_OF_DOOM: {
                return new BossChick();
            }
            case definitions.BOSS_ID.CENTICORE: {
                return new BossCenticore();
            }
            case definitions.BOSS_ID.CYCLOPS: {
                return new BossCyclops();
            }
            case definitions.BOSS_ID.FISH_MONSTER: {
                return new BossFishMonster();
            }
            case definitions.BOSS_ID.GIANT_SPIDER: {
                return new BossSpider();
            }
            case definitions.BOSS_ID.GNOME_BEAR: {
                return new BossGnomeBear();
            }
            case definitions.BOSS_ID.SUZIE: {
                return new BossSuzie();
            }
            case definitions.BOSS_ID.STEFAN: {
                return new BossStefan();
            }
            case definitions.BOSS_ID.QUEEN_MOLEWORM: {
                return new BossQueenMoleworm();
            }
        }
        return null;
    }
}